<template>
    <div class="contenedor_contenido">
        <div class="cabecera_contenido">

        </div>

        <div class="contenido_">
            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-2">
                        <h3>
                            Traslados
                        </h3>
                    </div>

                    <div v-if="ES_ROOT" class="col-sm-6 mt-3">
                        <label for="" class="form-label">Origen</label>
                        <select class="form-control form-control-sm" :disabled="bloquear_tienda_origen"
                            v-model="tienda_origen" @change="setear_sucursal_origen">
                            <option value="">Seleccionar</option>
                            <option v-for="(item, index) in QUITAR_BODEGA_CENTRAL" :key="index" :value="item.codigo">{{
                                item.nombre
                            }}</option>
                        </select>
                    </div>

                    <div :class="ES_ROOT ? 'col-sm-6 mt-3' : 'col-sm-12 mt-3'">
                        <label for="" class="form-label">Destino</label>
                        <select class="form-control form-control-sm" v-model="tienda_destino">
                            <option value="">Seleccionar</option>
                            <option v-for="(item, index) in QUITAR_BODEGA_CENTRAL" :key="index" :value="item.codigo">{{
                                item.nombre
                                }}</option>
                        </select>
                    </div>

                    <div class="col-sm-12 mt-3">
                        <label for="" class="form-label">Correlativo</label>
                        <input type="text" readonly class="form-control form-control-sm"
                            v-model="correlativos.TRASLADOS.extra">
                    </div>

                    <div class="col-sm-12 mt-3">
                        <div class="contenedor_texto_articulo">
                            {{ nombre_articulo }}
                        </div>
                    </div>

                    <div class="col-sm-6 mt-3">
                        <label for="" class="form-label">Código producto</label>
                        <input type="text" list="productos" :disabled="FILTRAR_PRODUCTOS_POR_SUCURSAL.length === 0"
                            id="campo_codigo_producto" placeholder="Doble click para buscar" @keyup.enter="set_datos_producto"
                            @keydown.tab="set_datos_producto" @dblclick="abrir_modal_de_busqueda_de_productos"
                            class="form-control form-control-sm" v-model="codigo_producto">
                        <!-- <datalist id="productos">
                            <option v-for="(item, index) in FILTRAR_PRODUCTOS_POR_SUCURSAL" :key="index"
                                :value="item.codigo">{{
                                    item.nombre
                                }}</option>
                        </datalist> -->
                    </div>

                    <div class="col-sm-2 mt-3">
                        <label for="" class="form-label">Precio</label>
                        <input type="number" step="0.01" id="campo_precio_producto_menu_traslado"
                            class="form-control form-control-sm" v-model="precio">
                    </div>

                    <div class="col-sm-2 mt-3">
                        <label for="" class="form-label">Cantidad</label>
                        <input type="number" id="campo_cantidad_producto" class="form-control form-control-sm"
                            v-model="cantidad">
                    </div>

                    <div class="col-sm-2 mt-5">
                        <button type="button" :disabled="btn_add" class="btn btn-sm btn-outline-dark btn-block"
                            @click="agregar_al_carrito"><i class="fas fa-plus"></i></button>
                    </div>

                    <div class="col-sm-12 mt-3">
                        <div class="marco_lista_productos_traslado">
                            <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                                <thead>
                                    <tr>
                                        <th style="width: 15%;text-align: center;">
                                            Código
                                        </th>
                                        <th style="width: 50%;">
                                            Artículo
                                        </th>
                                        <th style="width: 10%;text-align: center;">
                                            Cantidad
                                        </th>
                                        <th style="width: 15%;text-align: center;">
                                            Precio
                                        </th>
                                        <th style="width: 10%;text-align: center;">
                                            ...
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in carrito" :key="index">
                                        <td style="text-align: center;">
                                            {{ item.codigo }}
                                        </td>
                                        <td>
                                            {{ item.nombre }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ item.cantidad }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ item.precio }}
                                        </td>
                                        <td style="text-align: center;">
                                            <b-button type="button" size="sm" style="font-size: 10px;"
                                                variant="outline-danger" @click="borrar_registro(item)"><i
                                                    class="fas fa-trash"></i></b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="col-sm-12 mt-3">
                        <b-form-textarea v-model="comentarios" id="campo_comentarios" placeholder="Área de comentarios"
                            rows="3" max-rows="6"></b-form-textarea>
                    </div>

                    <div class="col-sm-12 mt-3">
                        <button v-if="permisos.traslados?.crear || ES_ROOT" type="button"
                            class="btn btn-sm btn-outline-dark btn-block" @click="enviar_traslado">Trasladar</button>
                        <button v-else type="button" disabled
                            class="btn btn-sm btn-outline-dark btn-block">Trasladar</button>
                    </div>

                </b-row>
            </b-container>
        </div>

        <ModalBusqueda v-if="modal_buscar_productos" :sucursal_seleccionada="tienda_origen" ,
            v-on:colocar="colocar_resultados_de_busqueda" />


    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { minix, pregunta } from '../functions/alertas';
import ModalBusqueda from '../Inventario/Movimientos/Entradas/ModalBusquedaProductos.vue';

export default {
    name: 'MenuTraslados',
    computed: {
        ...mapState(['sucursales', 'lista_productos', 'correlativos', 'permisos', 'datos_usuario', 'modal_buscar_productos', 'articulo_busqueda_seleccionado']),
        ...mapGetters(['ES_ROOT', 'QUITAR_BODEGA_CENTRAL', 'FILTRAR_PRODUCTOS_POR_SUCURSAL'])
    },
    components: {
        ModalBusqueda
    },
    data() {
        return {
            tienda_origen: '',
            tienda_destino: '',
            correlativo: '',
            codigo_producto: '',
            precio: '',
            cantidad: 1,
            comentarios: '',
            nombre_articulo: '-',
            carrito: [],
            btn_add: true,
            bloquear_tienda_origen: false
        }
    },
    methods: {
        abrir_modal_de_busqueda_de_productos() {
            this.set_modal_buscar_productos(true)
        },
        colocar_resultados_de_busqueda() {

            if (this.tienda_origen === '') {
                this.btn_add = true
                minix({ icon: 'error', mensaje: 'Seleccione una tienda', tiempo: 3000 })
            } else {
                this.btn_add = false
                this.precio = this.articulo_busqueda_seleccionado.precio_costo
                this.nombre_articulo = this.articulo_busqueda_seleccionado.nombre
                this.codigo_producto = this.articulo_busqueda_seleccionado.codigo
                document.getElementById('campo_precio_producto_menu_traslado').focus()

            }
        },
        set_datos_producto() {
            if (this.tienda_origen === '') {
                this.btn_add = true
                minix({ icon: 'error', mensaje: 'Seleccione una tienda', tiempo: 3000 })
            } else {
                this.btn_add = false
                let producto = this.FILTRAR_PRODUCTOS_POR_SUCURSAL.find(item => item.codigo == this.codigo_producto && item.sucursal == this.tienda_origen)
                if (producto == undefined) {

                    this.nombre_articulo = "-"

                } else {

                    this.precio = producto.precio_venta
                    this.nombre_articulo = producto.nombre

                }

            }

        },
        agregar_al_carrito() {

            if (this.nombre_articulo === '' || this.nombre_articulo === '-') {
                minix({ icon: 'error', mensaje: 'Seleccione un producto', tiempo: 3000 })
                document.getElementById('campo_codigo_producto').focus()
            } else {
                if (this.precio == '' || this.precio <= 0) {
                    minix({ icon: 'error', mensaje: 'El precio no puede ir vacio o ser igual a cero', tiempo: 3000 })
                    document.getElementById('campo_precio_producto_menu_traslado').focus()
                } else {
                    if (this.cantidad == '' || this.cantidad <= 0) {
                        minix({ icon: 'error', mensaje: 'La cantidad no puede ir vacia o ser igual a cero', tiempo: 3000 })
                        document.getElementById('campo_cantidad_producto').focus()
                    } else {


                        let f = {
                            codigo: this.codigo_producto,
                            nombre: this.nombre_articulo,
                            cantidad: this.cantidad,
                            precio: this.precio
                        }

                        this.carrito.push(f)

                        this.validar_elementos_en_carrito()

                        this.codigo_producto = ''
                        this.precio = ''
                        this.cantidad = 1
                        this.nombre_articulo = '-'

                        document.getElementById('campo_codigo_producto').focus()

                    }
                }
            }

        },

        async enviar_traslado() {

            if (this.tienda_origen == this.tienda_destino) {
                if (this.tienda_origen == '' && this.tienda_destino == '') {
                    minix({ icon: 'error', mensaje: 'Seleccione ambas sucursales', tiempo: 3000 })
                } else {
                    minix({ icon: 'error', mensaje: 'Las sucursales no pueden ser iguales', tiempo: 3000 })
                }
            } else {
                if (this.carrito.length == 0) {
                    minix({ icon: 'error', mensaje: 'La lista de productos no puede estar vacia', tiempo: 3000 })
                } else {
                    if (this.comentarios == '') {
                        minix({ icon: 'error', mensaje: 'Los comentarios no pueden estar vacios', tiempo: 3000 })

                        document.getElementById('campo_comentarios').focus()

                    } else {
                        let f = {
                            api: `movimientos-cabeceras/g/traslados`,
                            formulario: {
                                tienda_origen: this.tienda_origen,
                                tienda_destino: this.tienda_destino,
                                correlativo: this.correlativo,
                                carrito: this.carrito,
                                comentarios: this.comentarios
                            }
                        }

                        await this.guardar_data(f)
                        await this.obtener_correlativos()

                        this.bloquear_tienda_origen = false

                        this.tienda_origen = ''
                        this.tienda_destino = ''
                        this.carrito = []
                        this.comentarios = ''

                    }
                }
            }

        },
        borrar_registro(item) {

            pregunta({ titulo: 'Seguro que deseas borrar el registro?', texto: 'El elemento será removido de l la lista', afirmacion: 'Si, borrar!' }, async (i) => {
                if (i) {

                    this.carrito.splice(this.carrito.indexOf(item), 1)
                    this.validar_elementos_en_carrito()

                }
            })
        },
        setear_sucursal_origen() {

            this.nombre_articulo = '-'
            this.codigo_producto = ''


            if (this.ES_ROOT) {
                this.set_filtro_productos_sucursales_traslados(this.tienda_origen)
                if (this.FILTRAR_PRODUCTOS_POR_SUCURSAL.length == 0) {
                    this.btn_add = true
                }
            } else {
                this.tienda_origen = this.datos_usuario.sucursal_asignada
                this.set_filtro_productos_sucursales_traslados(this.datos_usuario.sucursal_asignada)
            }

        },
        validar_elementos_en_carrito() {
            if (this.carrito.length != 0) {
                this.bloquear_tienda_origen = true
            } else {
                this.bloquear_tienda_origen = false
            }
        },
        ...mapActions(['obtener_articulos', 'guardar_data', 'obtener_correlativos']),
        ...mapMutations(['set_filtro_productos_sucursales_traslados', 'set_modal_buscar_productos'])
    },
    mounted() {
        this.setear_sucursal_origen()
        this.obtener_articulos()
        this.obtener_correlativos()
    },
}
</script>

<style>
.marco_lista_productos_traslado {
    width: 100%;
    height: calc(100vh - 550px);
    border: 1px solid #e9e9e9;
    border-radius: 4px;
    overflow: auto;
}
</style>
